import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { ComponentContent, CONTENT_SIZES } from 'Layout';

import HeroInput from '../../../../../common/Hero/HeroInput/HeroInput';
import { HeroVehicle } from '../../../../../common/Hero/HeroVehicle/HeroVehicle';
import { useHeroRouteChangeHelpers } from '../../../../../common/Hero/Hooks/useHeroRouteChangeHelpers';
import Lock from '../../../../../fastlane/lock/Lock';
import TrustPilotImage from '../../../../../fastlane/TrustPilotImage/TrustPilotImage';
import useShowNewHomepage from '../../../../Hooks/useShowNewHomepage';
import { HeroProps } from '../../Hero';
import { PATHS } from '../../Hero.constants';
import { HeroContent } from '../HeroContent/HeroContent';

import styles from './HomepageVRM.scss';

type HomepageVRMProps = {
  inProgress?: boolean;
  isHomePageRedesign?: boolean;
  loadingHandler?: (value: any) => void;
} & HeroProps;

export const HomepageVRM = ({
  inProgress = false,
  isHomePageRedesign = false,
  loadingHandler,
}: HomepageVRMProps) => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);

  const {
    onNotMyCarClick: onNotMyCarClickHandler,
    setMileageUrl,
    showMileage,
  } = useHeroRouteChangeHelpers({ vehicle });

  const { showNewHomepage } = useShowNewHomepage();

  const HeroStrapline = (showMileage)
    ? (<HeroVehicle
      isCompactDesign={!isHomePageRedesign}
      {...{ onNotMyCarClickHandler, vehicle }}
      className={cx({ [styles.heroVehicleWrapper]: isHomePageRedesign })}
    />)
    : (<HeroContent />);

  return (
    <Lock lock={inProgress}>
      <div className={styles.flexWrapper}>
        <div className={cx(styles.vrmSection, {
          [styles.nextHomepage]: isHomePageRedesign && showNewHomepage,
        })}>
          <ComponentContent
            className={styles.component}
            maxWidth={CONTENT_SIZES.full}
          >
            { HeroStrapline }
          </ComponentContent>
          <div className={cx(styles.inputWrapper)}>
            <HeroInput
              setShowMileage={setMileageUrl}
              {...{
                inProgress,
                isHomePageRedesign,
                loadingHandler,
                showMileage,
                vehicle,
              }}
            />
          </div>
          <div className={cx(styles.socialValidationSection, {
            [styles.nextHomepage]: isHomePageRedesign && showNewHomepage,
          })}>
            <Link to={PATHS.review}>
              <TrustPilotImage className={styles.trustpilot} />
            </Link>
          </div>
        </div>
      </div>
    </Lock>
  );
};
